import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { TextField, Pagination } from '@mui/material';
import { useParams } from 'react-router-dom';
import GridLoader from '../ui/GridLoader';
import { H2 } from '../ui/HTags';
import SimpleJudgeRow from '../judge/SimpleJudgeRow';

const EventProgram = () => {
  const { eventId } = useParams();

  const [judges, setJudges] = useState([]);
  const [groupsOfEvent, setGroupsOfEvent] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = judges.length || 10;

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const getAllJudgesOfEvent = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(
        `/api/judges/get-judges-of-event/${eventId}`
      );
      setJudges(data);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.error_message);
    }
    setIsLoading(false);
  };

  const getGroupsOfEvent = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(
        `/api/groups/get-groups-of-event/${eventId}`
      );
      setGroupsOfEvent(data);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.error_message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getGroupsOfEvent();
    getAllJudgesOfEvent();
  }, []);

  if (isLoading) {
    return <GridLoader />;
  }

  const filterByName = (judge) =>
    judge.name.toLowerCase().includes(searchText.toLowerCase());
  const filterByEmail = (judge) =>
    judge.email.toLowerCase().includes(searchText.toLowerCase());
  const filteredJudges = judges.filter(
    (judge) => filterByName(judge) || filterByEmail(judge)
  );
  const totalPages = Math.ceil(filteredJudges.length / itemsPerPage);
  const paginatedJudges = filteredJudges.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const groupsPerJudge = groupsOfEvent.reduce((acc, group) => {
    group.judges.forEach((judge) => {
      if (!acc[judge._id]) {
        acc[judge._id] = null;
      }
      acc[judge._id] = group.name;
    });
    return acc;
  }, {});

  return (
    <div style={{ marginBottom: '6em' }}>
      <div className='col'>
        <div className='row'>
          <H2 className='text-xl'>Judges ({judges.length})</H2>
          {judges.length === 0 && <p>No judges yet</p>}
          <TextField
            id='search'
            search='search'
            label='Search by name or email '
            type='text'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            size='small'
            fullWidth
          />
        </div>
      </div>
      <div className='col'>
        <div className='row justify-between'>
          <div className='font-bold min-w-24'>Name</div>
          <div className='font-bold'>Session</div>
          <div className='font-bold'>Actions</div>
        </div>
        {paginatedJudges.map((judge) => (
          <div key={judge._id} className='row justify-between'>
            <SimpleJudgeRow judge={judge} group={groupsPerJudge[judge._id]} />
          </div>
        ))}
      </div>
      {/* <div className='pagination-container'>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color='primary'
        />
      </div> */}
    </div>
  );
};

export default EventProgram;
